import AddressBook from '../../assets/NAB_Ui.png';
import MeetProj from '../../assets/meet_proj.png';

var projectList = [
    {
        image: AddressBook,
        title: "NewAddressBook",
        description: "NewAddressBook is a desktop app that allows Singapore secondary" 
            + " school teachers to manage their contacts of students and colleagues"
            + " efficiently. It also supports keeping track of upcoming meetings."
            + " This was developed using Java and JavaFX.",
        link: 'https://ay2122s1-cs2103-t16-3.github.io/tp/'
    }, 
    {
        image: MeetProj,
        title: "Meet Me in the Middle",
        description: "A simple web app that helps to find a fair \"central\" location given multiple starting MRT stations." 
            + " This was developed using Flask for backend and ReactJS for frontend.",
        link: 'https://meet-me-in-middle.herokuapp.com/'
    }
];

export default projectList;